export default "__VITE_ASSET__94109eb0__"